import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import store from "./store";
import SignalR from "./plugins/signalR";
import Vue2Filters from "vue2-filters";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueQRCodeComponent from "vue-qrcode-component";
import VuetifyMoney from "vuetify-money";

Vue.component("qr-code", VueQRCodeComponent);
Vue.config.productionTip = false;
Vue.use(Vue2Filters);
Vue.use(SignalR);
Vue.use(VueSweetalert2);
Vue.use(VuetifyMoney);

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
